import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { PaymentMethodEnum } from 'common/enums/PaymentMethodEnum'
export const usePaymentMethodsWithGeneralStripe = (
  paymentMethods: PaymentMethodEnum[],
) => {
  const { t } = useTranslation('common')

  return useMemo(() => {
    const stripeValues: PaymentMethodEnum[] | null = []
    const otherMethods = new Set<PaymentMethodEnum>()

    paymentMethods.forEach(method => {
      if (method.startsWith('stripe:ideal')) {
        stripeValues.push(method)
        otherMethods.add(PaymentMethodEnum.StripeGeneral)
      } else {
        otherMethods.add(method)
      }
    })

    return {
      methods: Array.from(otherMethods) as PaymentMethodEnum[],
    }
  }, [paymentMethods, t])
}
